











export default {
  props: {
    size: {
      type: [
        Number,
        String,
      ],
      default: 1,
    },
  },
} as IView;
